module.exports = __webpack_public_path__ + "img/us_electricity_generation.048b018f.jpg";